angular.module('tgaApp').controller('InputBoxController', [
  '$scope', '$translate', 'gameTrackingService', 'analyticsService', '$log',
  'soundService', 'APIService', 'gameDataService', '$document', 'utilityService', '$filter',
  function (
    $scope, $translate, gameTrackingService, analyticsService, $log,
    soundService, APIService, gameDataService, $document, utilityService, $filter,
  ) {
    $scope.initialize = () => {
      $scope.reset();
      $document[0].addEventListener('keydown', this.keyDownHandler);
    };
    $scope.questionVariables = {
      hasFeedback: false,
      feedbackComplete: false,
      feedbackText: '',
      questionAnswered: false,
      questionCorrect: false,
      timedOut: false,
      answerInput: '',
      canSubmit: false,
      answers: null,
      correct: false,
    };

    angular.element('input').focus();

    $scope.onKeydown = function (e) {
      if (e.keyCode === 13 && !$scope.questionVariables.questionAnswered) {
        // submit answer on enter key press
        $scope.submitAnswer();
        e.preventDefault();
      }
    };

    $scope.readInput = function () {
      $scope.value = this.value.trim();
      $scope.questionVariables.canSubmit = !!this.value.length;
    };

    $scope.submitAnswer = function () {
      $scope.questionVariables.correct = false;
      $scope.stopQuestionAudio($scope.currentQuestion.question_id);
      if ($scope.submitted) return;
      $scope.error = null;
      const data = gameTrackingService.get();
      $scope.submitted = true;
      $scope.$broadcast('timer-stop');

      APIService.reportAnswer(
        {
          game_id: $scope.gameData.data.game_id,
          question_id: $scope.question.question_id,
          language_id: $scope.gameData.data.language_id,
          points: {
            // send 0 if previouslyAnswered
            correct: $scope.$parent.getPoints($scope.question.points_correct) || 0,
            incorrect: $scope.$parent.getPoints($scope.question.points_incorrect) || 0,
          },
          time: Date.now() - $scope.questionTime,
          answer_text: $filter('trimLower')($scope.value),
        },
        (response) => {
          $scope.answeredCorrect = response.correct;
          $scope.questionVariables.correct = $scope.answeredCorrect;
          // eslint-disable-next-line max-len
          if (!$scope.questionVariables.timedOut) {
            $scope.questionVariables.questionAnswered = true;
            $scope.gameData.questionAnswered = true;
            $scope.questionVariables.answers = response;
          }
          // $scope.questionVariables.answers = -1;
          soundService.play($scope.answeredCorrect ? 'correct' : 'wrong');
          this.receivedCorrectnessValue();
          $scope.$emit('calculatePoints', { points: $scope.$parent.getPoints($scope.pointsAwarded) });
          // eslint-disable-next-line max-len
          const hasFeedback = ($scope.questionVariables.timedOut
              && ($scope.question.response_timeout || $scope.question.response_timeout_image.original))
            // eslint-disable-next-line max-len
            || ($scope.answeredCorrect
              && ($scope.question.response_correct || $scope.question.response_correct_image.original))
            // eslint-disable-next-line max-len
            || (!$scope.answeredCorrect
              && ($scope.question.response_incorrect || $scope.question.response_incorrect_image.original));
          $scope.questionVariables.hasFeedback = hasFeedback;
          // eslint-disable-next-line max-len
          $scope.$emit('showFeedbackResults', {
            data: $scope.question,
            returned: response,
            questionVariables: $scope.questionVariables,
          });
        },
        () => {
          $scope.reset();
          $scope.error = $translate.instant('scenarios.error.connection-error').toString();
        },
      );
      this.receivedCorrectnessValue = () => {
        gameTrackingService.update('questionsAsked', data.questionsAsked + 1);
        /** Points * */
        // Determine points awarded
        $scope.pointsAwarded = null;

        if ($scope.answeredCorrect && $scope.question.points_correct) {
          $scope.pointsAwarded = $scope.$parent.getPoints($scope.question.points_correct);
        } else if (!data.correct && $scope.question.points_incorrect) {
          $scope.pointsAwarded = $scope.$parent.getPoints($scope.question.points_incorrect);
        }
        if ($scope.answeredCorrect) {
          $scope.gameData.nextCardId = $scope.question.next_question_id_correct;
          $scope.gameData.questionsAnsweredCorrect++;
          gameTrackingService.update('questionsCorrect', data.questionsCorrect + 1);
          gameTrackingService.update('streak', data.streak + 1);
          gameTrackingService.update('score', data.score + $scope.pointsAwarded);
          const isUniqueCorrect = data.uniqueCorrect.some((q_id) => $scope.question.question_id === q_id);
          if (!isUniqueCorrect) {
            const arr = data.uniqueCorrect.concat([$scope.question.question_id]);
            gameTrackingService.update('uniqueCorrect', arr);
          }
        } else {
          // moved timeOut nextCardId to here to prevent being overwritten
          $scope.gameData.nextCardId = $scope.questionVariables.timedOut
            ? $scope.question.next_question_id_timeout
            : $scope.question.next_question_id_incorrect;
          gameTrackingService.update('streak', 0);
        }

        // eslint-disable-next-line max-len
        const hasFeedback = ($scope.questionVariables.timedOut && ($scope.question.response_timeout || $scope.question.response_timeout_image.original))
                          // eslint-disable-next-line max-len
                          || ($scope.answeredCorrect && ($scope.question.response_correct || $scope.question.response_correct_image.original))
                          // eslint-disable-next-line max-len
                          || (!$scope.answeredCorrect && ($scope.question.response_incorrect || $scope.question.response_incorrect_image.original));
        $scope.questionVariables.hasFeedback = hasFeedback;

        // add question to history modal
        const answersWithSelection = angular.copy($scope.question.answers);
        answersWithSelection.answerObject = $scope.questionVariables;
        answersWithSelection.userAnswer = $scope.value;
        $scope.gameData.answerHistory.push({
          questionData: angular.copy($scope.question),
          answerData: answersWithSelection,
          open: false,
        });

        $log.debug('pointsAwarded', $scope.pointsAwarded);
        analyticsService.sendEvent({
          category: 'question',
          action: 'answered',
          label: $scope.answeredCorrect ? 'correct' : 'incorrect',
          value: $scope.question.question_id,
        });
        $scope.$emit('questionAnswered');
      };
    };

    // times up
    $scope.$on('countdown-complete', () => {
      $scope.questionVariables.timedOut = true;
      $scope.answeredCorrect = false;
      $scope.questionVariables.questionAnswered = false;
      $scope.gameData.questionAnswered = false;
      $scope.submitAnswer();
    });
    $scope.reset = () => {
      $scope.submitted = false;
      $scope.answeredCorrect = null;
      $scope.value = '';
      $scope.canSubmit = false;
      $scope.error = null;
      $scope.answer = null;
      $scope.question = $scope.$parent.currentQuestion;
      // eslint-disable-next-line max-len
      if ($scope.question.randomize_answers) $scope.question.answers = utilityService.shuffleArray($scope.question.answers);
      $scope.isMobile = $scope.$parent.isMobile;
      $scope.game = gameDataService.get();
      $scope.playAudio = $scope.$parent.playAudio;
      $scope.questionHasAudio = !!$scope.question?.audio?.url;
      $scope.questionTime = Date.now();
    };

    $scope.initialize();
  },
]);
